import { Entity, ReportType } from '@nx-smartmonkey/shared/domain';

export interface StopReportDTO {
  id: string;
  stop_id: string;
  type: ReportType;
  comments?: boolean;
  images?: Array<StopReportImage>;
  signature?: boolean;
  custom_fields?: StopReportCustomField;
  created_at: Date;
}

interface StopReportCustomField {
  [key: string]: boolean | string | number | undefined;
}

interface StopReportImage {
  id: string;
  url: string;
}

export interface StopReportProps {
  stop_id: string;
  type: ReportType;
  comments?: boolean;
  images?: boolean;
  signature?: boolean;
  custom_fields?: boolean;
  tasks_completed: number;
  tasks_total: number;
  created_at: Date;
}

export class StopReport extends Entity<StopReportProps> {
  get id(): string {
    return this._id!;
  }

  get stop_id(): string {
    return this.props.stop_id;
  }

  get type(): ReportType {
    return this.props.type;
  }

  get comments(): boolean | undefined {
    return this.props.comments;
  }
  get images(): boolean | undefined {
    return this.props.images;
  }
  get signature(): boolean | undefined {
    return this.props.signature;
  }
  get custom_fields(): boolean | undefined {
    return this.props.custom_fields;
  }

  get tasks_completed(): number {
    return this.props.tasks_completed;
  }

  get tasks_total(): number {
    return this.props.tasks_total;
  }

  get created_at(): Date {
    return this.props.created_at;
  }
  static create(props: StopReportProps, id: string) {
    return new StopReport(props, id);
  }
}
